import { HttpForm } from "../Support/HttpForm";
import { Campaign } from "./Campaign";
import { axios } from "../Support/Axios";
export class CampaignProducts extends HttpForm {
    data = {};
    account;
    slug;
    campaign;
    metrics = false;
    constructor(app, params) {
        super();
        this.campaign = new Campaign(app);
        this.account = params.account;
        this.slug = params.slug;
    }
    mount() {
        Promise.all([
            this.campaign.getCampaign(this.slug),
            this.campaignProductMetrics(),
        ]).then(() => {
            this.setLoadingState(true);
        }).catch(e => this.setError(e));
    }
    campaignProductMetrics() {
        const url = '/api/campaign/' + this.slug + '/product/metrics';
        return axios.get(url)
            .then((response) => {
            this.metrics = response.data.data;
        })
            .catch(e => this.setError(e));
    }
    toggleProductSelection(event) {
        const url = '/api/campaign/' + this.slug + '/product';
        return new Promise(resolve => {
            axios.patch(url, event)
                .then((response) => {
                this.campaignProductMetrics()
                    .then(() => resolve(true));
            }).catch(e => this.setError(e));
        });
    }
}
